import React from 'react';

import styled from 'styled-components';

import { Divider } from 'components/lib/Divider';

import CompaniesCreateEditModalContentBasic from './CompaniesCreateEditModalContentBasic';
import CompaniesCreateEditModalContentEmpty from './CompaniesCreateEditModalContentEmpty';
import CompaniesCreateEditModalContentMysteryShopping from './CompaniesCreateEditModalContentMysteryShopping';
import CompaniesCreateEditModalContentPrimary from './CompaniesCreateEditModalContentPrimary';
import { useCompaniesCreateEditModalContext } from './CompaniesCreateEditModalContext';
import { COMPANY_EMPTY_CONTENT, COMPANY_STATUS } from '../constants';

const Container = styled.div`
  padding: 20px 30px 0px 30px;
`;

const FlexContainer = styled.div`
  display: flex;
  gap: 20px;
  height: 55vh;
  min-width: 1010px;
  flex-basis: fit-content;
  overflow-x: scroll;
`;

const CompaniesCreateEditModalContent = () => {
  const { company } = useCompaniesCreateEditModalContext();
  const showMysteryShop = [COMPANY_STATUS.IN_TRIAL, COMPANY_STATUS.PAYING_CUSTOMER, COMPANY_STATUS.INACTIVE].includes(
    company?.status
  );
  const showPrimaryContent = showMysteryShop || COMPANY_STATUS.DEMO === company?.status;
  const showContentEmpty = [COMPANY_STATUS.DEMO, COMPANY_STATUS.OUTSIDE_COMPANY].includes(company?.status);

  return (
    <Container>
      <CompaniesCreateEditModalContentBasic />
      <Divider />
      <FlexContainer className="mini-scroll">
        {showPrimaryContent && <CompaniesCreateEditModalContentPrimary />}
        {showMysteryShop && <CompaniesCreateEditModalContentMysteryShopping />}
        {showContentEmpty && <CompaniesCreateEditModalContentEmpty {...COMPANY_EMPTY_CONTENT[company?.status]} />}
      </FlexContainer>
    </Container>
  );
};

export default CompaniesCreateEditModalContent;
